// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WidgetWrapper_wrapper__gXqr7","clickable":"WidgetWrapper_clickable__2Fr47"};